import { UserAuthenticationType } from "@fairfleet/geotab";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { FormPanelProps, FormSwitch, FormTextField } from "./formFields";

const AUTHENTICATION_TYPES = [
  "BasicAuthentication",
  "WindowsAuthentication",
  "SAML",
  "MyAdmin",
];

interface Props extends FormPanelProps {
  isCreating: boolean;
}

export function SystemCommunicationsTab({ form, setField, isMobile, isCreating }: Props) {
  const { t } = useTranslation();
  const bind = { form, setField };
  return (
    <Stack spacing={1.25}>
      <TextField
        label={t("users.authenticationType")}
        value={form.userAuthenticationType}
        onChange={event =>
          setField("userAuthenticationType", event.target.value as UserAuthenticationType)
        }
        fullWidth
        size="small"
        select
      >
        {AUTHENTICATION_TYPES.map(type => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </TextField>
      {form.userAuthenticationType === "WindowsAuthentication" ? (
        <FormTextField
          {...bind}
          field="windowsAuthenticationUserId"
          label={t("users.windowsAuthenticationUserId")}
        />
      ) : null}
      <FormSwitch {...bind} field="changePassword" label={t("users.forcePasswordChange")} />
      {isCreating && form.userAuthenticationType === "BasicAuthentication" ? (
        <FormTextField {...bind} field="password" label={t("users.password")} type="password" />
      ) : null}
      <Stack direction={isMobile ? "column" : "row"} spacing={1.25}>
        <FormSwitch
          {...bind}
          field="isEmailReportEnabled"
          label={t("users.isEmailReportEnabled")}
        />
        <FormSwitch {...bind} field="isNewsEnabled" label={t("users.isNewsEnabled")} />
        <FormSwitch
          {...bind}
          field="isServiceUpdatesEnabled"
          label={t("users.isServiceUpdatesEnabled")}
        />
      </Stack>
    </Stack>
  );
}
